import { profileService } from 'config/api';
import actionTypes from './actionTypes';

export const getClientOnlineBag = (requestBody) => async (dispatch) => {
  dispatch({ type: actionTypes.CLIENT_GET_ONLINE_BAG_TAB_LOADING });

  try {
    const { data } = await profileService.post('/clientOnlineBag', requestBody);

    dispatch({
      type: actionTypes.CLIENT_GET_ONLINE_BAG_TAB_SUCCESS,
      payload: data,
    });
  } catch (err) {
    const error = err.response?.data?.message || 'Client Online Bag Tab error';
    dispatch({
      type: actionTypes.CLIENT_GET_ONLINE_BAG_TAB_ERROR,
      payload: error,
    });
  }
};

export const clearClientOnlineBag = () => ({
  type: actionTypes.CLIENT_GET_ONLINE_BAG_TAB_CLEAR,
});

export const searchOnlineBags = (requestBody) => async (dispatch) => {
  dispatch({ type: actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_LOADING });

  try {
    const { data } = await profileService.post('/clientOnlineBag', requestBody);

    dispatch({
      type: actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_SUCCESS,
      payload: data,
    });
  } catch (err) {
    const error = err.response?.data?.message || 'SEARCH - Client Online Bag Tab error';
    dispatch({
      type: actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_ERROR,
      payload: error,
    });
  }
};

export const clearSearchOnlineBags = () => ({
  type: actionTypes.CLIENT_SEARCH_ONLINE_BAG_TAB_CLEAR,
});

export const setOnlineBagFilters = (onlineBagFilterSelection) => ({
  type: actionTypes.CLIENT_SET_ONLINE_BAG_FILTERS_SELECTION,
  payload: onlineBagFilterSelection,
});

export const setOnlineBagSort = (onlineBagSortSelection) => ({
  type: actionTypes.CLIENT_SET_ONLINE_BAG_SORT_SELECTION,
  payload: onlineBagSortSelection,
});

export const setOnlineBagCountOfNewClientForNotification = (newCount) => ({
  type: actionTypes.CLIENT_SET_NEW_COUNT_FOR_ONLINE_BAG_NOTIFICATION,
  payload: newCount,
});
